import { render, staticRenderFns } from "./TdxInputLabelErrorWrapper.vue?vue&type=template&id=70f358fe&scoped=true&"
import script from "./TdxInputLabelErrorWrapper.vue?vue&type=script&lang=js&"
export * from "./TdxInputLabelErrorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TdxInputLabelErrorWrapper.vue?vue&type=style&index=0&id=70f358fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f358fe",
  null
  
)

export default component.exports